export default __webpack_public_path__ + "static/media/Proxima_Station_LE.5d7b9ed8.jpg";